import { Component, QueryList, ViewChildren } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from '../../../services/data/data.service';
import { Aligment, ExcelService, FormatText } from '../../../services/excel/excel.service';
import { SegPresupuestalService } from '../../../services/segimiento-presupuestal/seg-presupuestal.service';
import { FiltersM, typesApex } from '../../../components/models';
import { messages } from '../../funciones/mensajes';
import { firstValueFrom } from 'rxjs';
import { GraficadorComponent } from '../../../components/graficador/graficador.component';
import { companiesSegPresupuestal } from '../../../shared/catalogos';
import { cuentaEntity, detalleCuentaEntity, evaluacionesAllEntity, sucursalesEntity, varTipoEntity } from '../../../services/segimiento-presupuestal/Manual/entities';
import { Periodos } from '../funcionesFormuladorSeguimiento';
import { obtenerSegmentos } from '../idsTabla';

@Component({
  selector: 'app-analisis-segmento',
  templateUrl: './analisis-segmento.component.html',
  styleUrl: './analisis-segmento.component.css'
})
export class AnalisisSegmentoComponent {
  public Filters = FiltersM;
  public miles = ',';
  public decimal = '.';
  // Propiedades para períodos
  public Periodos: any[] = [];
  public periodoSeleccionado: any = null;
  public escenarios: any[] = [];
  public escenariosShow: any[] = [];
  public escenarioSeleccionado;
  public sucursales: any[] = [];
  public consolidado: boolean = true;
  public sucursalSeleccionada;
  private institucionId = undefined;
  private templateId = undefined;
  private idBase: number;
  public encMet: number = 1; //1 -> consolidado 2->Saldos y movimientos
  public consolidadoSeg = false;
  public segmentoEnc;
  public segmentos = [];
  public dataSegmentos = [];
  public segmentosJerarquia
  public dataVisible = [];
  public segmentoSelect;
  public sinSaldo = false;
  // Propiedades para semáforos
  public semaforosVariacion: any[] = [];
  public semaforos: any[] = [];
  public semaforo = false;
  public contraerExpandir: boolean = false; //false -> contraer todo   true -> expandir todo
  public dataGraf = [];
  public etiquetasGraf;
  public etiqueta: boolean = false;
  public typeGraph = typesApex
  public tipoGraf = this.typeGraph.COMBO2;
  public coloresGrafico: string[] = ['#00255c', '#018fbf', '#8ad3e6']; 
  public axisY: string[] = ['Cumplimiento (%)', 'Ejecutado'];
  public ejes = true;
  public axisX: string = '';
  @ViewChildren(GraficadorComponent)grafCmp!:QueryList<GraficadorComponent>;
  public subtituloGrafica:string = "";
  private posSelect = 0;

  public modalOpen:boolean = false;
  public tagInstitucion: number;


  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    public cookies: CookieService,
    private excelService: ExcelService,
    private segPresupuestalService: SegPresupuestalService,
  ) {
    this.institucionId = this.cookies.get('idInstitucion');
    this.idBase = companiesSegPresupuestal.find(i => i.id == this.institucionId).idBack;
    this.personalizacion();
    this.initEscenarios();
    this.initSucursales();
  }
  private personalizacion(){
    this.tagInstitucion = companiesSegPresupuestal.find( i => i.id == this.institucionId).etiquetas;
  }

  private async initEscenarios() {
    try{
      let sucursalEntity: sucursalesEntity = {agrupadorId: this.idBase, tipoInstitucionId: 3};
      let res = await firstValueFrom(this.segPresupuestalService.getSucursales(sucursalEntity));
      this.escenarios = res.map(({ institucion, ...rest}) => ({
        name: institucion.split('|')[1],
        check: false,
        ...rest
      }))
      this.escenarios[0].check = true;
    }catch(e){
      console.warn(e);
      messages.errorMessageGraph(e.error);
    }
  }
  private async initSucursales() {
    try{
      let res = [];
      let sucursalEntity: sucursalesEntity =  {id: this.idBase};
      const matriz = await firstValueFrom(this.segPresupuestalService.getSucursales(sucursalEntity));
      this.templateId = matriz[0].plantillaId;
      let consolidado = {name: 'Consolidado', consolidado: true, check: true, id: this.idBase};
      this.sucursales.push(consolidado)
      sucursalEntity = {agrupadorId: this.idBase, tipoInstitucionId: 5};
      res = await firstValueFrom(this.segPresupuestalService.getSucursales(sucursalEntity));
      const resFiltro = res.filter(i => ((i.acronimo).toLowerCase()).includes('real'));
      const resEsce = res.filter(i => ((i.acronimo).toLowerCase()).includes('presupuesto'));
      const s = new Set();
      const sucur = resFiltro.map(({ institucion, ...rest}) => ({
        name: institucion.split('|')[1],
        consolidado: false,
        check: false,
        ...rest,
      })).filter( i => {
        if(s.has(i.name))
          return false;
        s.add(i.name);
        return true;
      });
      this.sucursales.push(... sucur);
      for(const suc of this.sucursales){
        if(suc.consolidado){
          suc['instEsce'] = this.escenarios;
        }else{
          const nombreSucursal = suc.name.trim().toLowerCase();

          suc.instEsce = resEsce.filter(item =>
            item.institucion.toLowerCase().includes(nombreSucursal)
          );
        }        
      }
      this.sucursalSeleccionada = this.sucursales[0];
      this.initPeriodos();
    }catch(e){
      console.warn(e)
      messages.errorMessageGraph(e.error);
    }
  }
  private async initPeriodos() {
    try{
      let evaluaciones: evaluacionesAllEntity = {plantillaId: this.templateId, institucionId: this.sucursalSeleccionada.id};
      const evaReal = await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluaciones));
      const info = Periodos.evaluacionesPresupuestoReal(evaReal, []);
      this.Periodos = info.periodos;
      this.periodoSeleccionado = info.perSeleccionado;
      evaluaciones = {plantillaId: this.templateId, periodo: this.periodoSeleccionado.periodo};
      const escenarioDis =  await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluaciones));
      this.escenariosShow = escenarioDis.filter(e => e.institucionId !== this.sucursalSeleccionada.id && e.institucion_entity.agrupadorId === this.sucursalSeleccionada.id)
        .map((e, i) => {
          return {
            name: e.institucion_entity.institucion.split(' | ')[1],
            check: i===0,
            idPresupuesto: e.id,
            ...e.institucion_entity
          }
        });
      this.escenarioSeleccionado = this.escenariosShow[0];
      this.initSegmentos();
    }catch(e){
      console.warn(e);
      messages.errorMessageGraph(e.error);
    }
  }
  private async initSegmentos(){
    if (!this.templateId) {
      this.dataSegmentos = [];
      return;
    }
    try{
      let cuentaDesc: cuentaEntity = {plantillaId: this.templateId}
      let res: any = await firstValueFrom(this.segPresupuestalService.getCuentasDescripcion(cuentaDesc));
      let idsSegmentos = obtenerSegmentos.idsSegmentos(this.templateId);
      this.segmentos = [];
      idsSegmentos.forEach((s, i) => {
        let seg = res.filter(d => d.code == s.id);
        this.segmentos.push({
          name: seg[0].cuenta,
          check: false,
          id: seg[0].id,
          movimientos: s.movimiento
        })
      });
      this.segmentos[this.posSelect].check = true;
      this.segmentoEnc = this.segmentos[this.posSelect];
      let cuentaValor: detalleCuentaEntity = {idEvaluacion: this.periodoSeleccionado.idReal};
      const dataReal = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));
      const idEvaEsce = this.escenariosShow.find(e => e.check);
      cuentaValor = {idEvaluacion: idEvaEsce.idPresupuesto};
      const dataPresupuesto = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));

      //obtencion de movimientos del mes 
      const periodos = this.Periodos.flatMap(a => a.series);
      const indice = periodos.findIndex(p => p.check);
      const periodoAnterior =
        indice === -1
          ? null
          : periodos[indice].mes === 'ene'
            ? periodos[indice]
            : periodos[indice - 1];

      const evaluacionesAn = {plantillaId: this.templateId, periodo: periodoAnterior.periodo};
      const escenarioDisAn =  await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluacionesAn));
      const es = escenarioDisAn.filter(e => e.institucionId !== this.sucursalSeleccionada.id && e.institucion_entity.agrupadorId === this.sucursalSeleccionada.id)
      .map((e, i) => {
        return {
          name: e.institucion_entity.institucion.split(' | ')[1],
          check: i===0,
          idPresupuesto: e.id,
          ...e.institucion_entity
        }
      })
      .find(e => e.name === idEvaEsce.name);
      cuentaValor = {idEvaluacion: periodoAnterior.idReal};
      const dataRealMov = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));
      cuentaValor = {idEvaluacion: es.idPresupuesto};
      const dataPresupuestoMov = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));

      if (!res || res.length === 0) {
        this.dataSegmentos = [];
        return;
      }

      // Generar semáforos para la institución actual
      this.generarSemaforosParaInstitucion();

      this.dataSegmentos = res.map((r: any) => {
        let presupuesto, real, cumplimiento, cumplimientoMov, presupuestoMov, realMov;
        presupuesto = dataPresupuesto.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor > 0 
              ? Number((dataPresupuesto.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor).toFixed(2)) : '-';
        real = dataReal.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor > 0 
              ? dataReal.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor : '-';
        presupuestoMov = dataPresupuestoMov.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor > 0 
              ? dataPresupuestoMov.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor : '-';
          presupuestoMov = presupuestoMov !== '-' ? Number((presupuesto - presupuestoMov).toFixed(2)) : '-';
        realMov = dataRealMov.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor > 0 
              ? dataRealMov.data.detalleEvaluacionCuentas.find(i => i.idCuenta === r.id).valor : '-';
          realMov = realMov !== '-' ? Number((real - realMov).toFixed(2)) : '-';
        cumplimiento = !isNaN((100 * real) / presupuesto) ? Number(((100 * real) / presupuesto).toFixed(2)) : '-';
        cumplimientoMov = !isNaN((100 * realMov) / presupuestoMov) ? Number(((100 * realMov) / presupuestoMov).toFixed(2)) : '-';        
        
        return {
          id: r.id,
          codigo: r.code,
          nombre: r.cuenta ?? r.variable,
          nivel: 0,
          cuentaPadre: r.cuentaPadreId ?? -1,
          hijos: [],
          expandido: false,
          visible: true,
          segVisible: false,
          presupuesto: presupuesto,
          real: real,
          variacion: this.calcularVariacion(presupuesto, real),
          cumplimiento: cumplimiento,
          analisisVerticalPresupuesto: 0,
          analisisVerticalReal: 0,
          presupuestoMov: presupuestoMov,
          realMov: realMov,
          variacionMov: this.calcularVariacion(presupuestoMov, realMov),
          cumplimientoMov: cumplimientoMov,
          analisisVerticalPresupuestoMov: 0,
          analisisVerticalRealMov: 0
        };
      });
      this.organizarJerarquia();
      this.segmentoSelect = this.dataVisible[0];
      this.historicoSegmento();
    }catch(e){
      console.warn(e);
      messages.errorMessageGraph(e.error);
    }    
  }
  private organizarJerarquia() {
    const plantilla = this.templateId === 4 ? 'idsCuentasP4' : '';

    const cuentasOrdenadas = this.dataSegmentos
      .map(cuenta => {
        const config = obtenerSegmentos[plantilla]?.(cuenta.codigo)?.[0];

        return {
          cuenta,
          nivel: config?.nivel,
          pos: config?.pos
        };
      })
      .filter(item => item.nivel !== undefined && item.pos !== undefined)
      .sort((a, b) => a.pos - b.pos || a.cuenta.codigo.localeCompare(b.cuenta.codigo));

    const cuentasRaiz: any[] = [];
    const pila: any[] = [];

    cuentasOrdenadas.forEach(({ cuenta, nivel }) => {
      while(pila.length > 0 &&pila[pila.length - 1].nivel >= nivel){
        pila.pop();
      }
      const padre = pila[pila.length-1];
      const segmentoId = nivel === 1 
        ? cuenta.id : padre?.segmentoId;

      const nodo = {
        ...cuenta,
        nivel,
        segmentoId,
        hijos: [],
        expandido: false,
        visible: true
      };
      if (padre) {
        padre.hijos.push(nodo);
        nodo.visible = false;
      } else {
        cuentasRaiz.push(nodo);
      }

      pila.push(nodo);
    });

    this.segmentosJerarquia = cuentasRaiz;
    this.expandirTodo();
  }
  private expandirTodo() {
    const recorrer = (cuentas:any[]) => {
      cuentas.forEach(cuenta => {
        cuenta.expandido = true;
        // if(cuenta.nivel > 2){
          recorrer(cuenta.hijos);
        // }
      });
    }
    recorrer(this.segmentosJerarquia);
    this.actualizarCuentasVisibles();
  } 
  private actualizarCuentasVisibles() {
    var plantilla = '';
    if(this.templateId === 4){
      plantilla = 'idsCuentasP4';
    }
    this.dataVisible = [];
    const recorrer = (cuentas: any[]) => {
      cuentas.forEach(cuenta => {
        if(obtenerSegmentos[plantilla](cuenta.codigo) !== undefined){
          if((this.sinSaldo && cuenta.presupuesto !== '-' || cuenta.real !== '-') || !this.sinSaldo){
            this.dataVisible.push(cuenta);
            if (cuenta.expandido && cuenta.hijos.length > 0) {
              recorrer(cuenta.hijos);
            } 
          }
        }
      });
    };
    recorrer(this.segmentosJerarquia);
  }
  public async historicoSegmento(){
    this.dataGraf = [];
    const idEvaEsce = this.escenariosShow.find(e => e.check)
    const evaluacionesAn: evaluacionesAllEntity = {plantillaId: this.templateId, institucionId: idEvaEsce.id};
    const escenarioDisAn =  await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluacionesAn));
    const periodosEsce = escenarioDisAn.slice(0,escenarioDisAn.findIndex(i => i.periodo === this.periodoSeleccionado.periodo)+1);
    const periodos = (this.Periodos.find(a => a.series.find(m => m.check))).series;
    const indiceCheck = periodos.findIndex(p => p.check);
    const ultimosPeriodos = indiceCheck === -1
      ? []
      : periodos.slice(0, indiceCheck + 1);
    this.etiquetasGraf = ultimosPeriodos.map( p => { return `${this.translate.instant('filtros.'+p.mes)} ${p.anio}`; });

    // Inicializar arrays para los 12 meses
    let presupuestos: number[] = [];
    let reales: number[] = [];
    let metas: number[] = [];
    try{
      let cuentaValor: detalleCuentaEntity;
      for(let i = 0; i < ultimosPeriodos.length; i++){
        cuentaValor = {idEvaluacion: ultimosPeriodos[i].idReal, IdCuenta: this.segmentoSelect.id}
        const r = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));
        const vr = Number((r.data.detalleEvaluacionCuentas[0].valor).toFixed(2));
        reales.push(vr);
        cuentaValor = {idEvaluacion: periodosEsce[i].id, IdCuenta: this.segmentoSelect.id};
        const pr = await firstValueFrom(this.segPresupuestalService.getCuentasValor(cuentaValor));
        const vpr = Number((pr.data.detalleEvaluacionCuentas[0].valor).toFixed(2));
        presupuestos.push(vpr);
        //TODO: falta checar de donde se obtiene el parametro meta 
        metas.push(!isNaN((100 * vpr) / vr) ? Number(((100 * vpr) / vr).toFixed(2)) : 0);
      }
      this.dataGraf = [
        {
          name: '% cumplimiento',
          data: metas
        },
        {
          name: 'Presupuesto',
          data: presupuestos
        },
        {
          name: this.translate.instant('segPresupuestal.analisisSegmento.titTab4'),
          data: reales
        },      
      ];
    }catch(e){
      messages.errorMessageGraph(e.error);
      console.warn(e)
    }
  }
  public async cambioPeriodo(per: any) {
    if (!per) return;
    
    // Si el objeto tiene propiedades 'mes' y 'anio', es un mes
    if (per.mes && per.anio) {
      // Actualizar solo el mes seleccionado
      this.Periodos.forEach(p => {
        if (p.series) {
          p.series.forEach(mes => {
            mes.check = (mes.mes === per.mes && mes.anio === per.anio);
          });
        }
      });
      this.periodoSeleccionado = per;
      const evaluaciones = {plantillaId: this.templateId, periodo: this.periodoSeleccionado.periodo};
      const escenarioDis =  await firstValueFrom(this.segPresupuestalService.getPeriodosAll(evaluaciones));
      const eseneriosAMost = escenarioDis.filter(e => e.institucionId !== this.sucursalSeleccionada.id && e.institucion_entity.agrupadorId === this.sucursalSeleccionada.id)
      .map((e, i) => {
        return {
          name: e.institucion_entity.institucion.split(' | ')[1],
          check: i===0,
          idPresupuesto: e.id,
          ...e.institucion_entity
        }
      });

      const iguales = eseneriosAMost.length === this.escenariosShow.length &&
        eseneriosAMost.every((item, i) => item.name === this.escenariosShow[i].name);
      if(!iguales){
        this.escenariosShow = eseneriosAMost;
      }else{
        this.escenariosShow.forEach( e => {
          const es = eseneriosAMost.find(ee => ee.name === e.name);
          e.idPresupuesto = es.idPresupuesto ?? e.idPresupuesto;
        });
      }
      this.escenarioSeleccionado = this.escenariosShow.find(e => e.check);
      this.initSegmentos();
    }    
  }

  public escenarioChange(escClick: any) {
    if (!escClick || !escClick.name) return;

    this.escenariosShow.forEach(e => e.check = (e.name === escClick.name));
    const seleccionado = this.escenariosShow.find(e => e.check);
    this.escenarioSeleccionado = seleccionado;
    this.initSegmentos();
  }

  public async sucursalChange(sucClick: any) {
    for (const suc of this.sucursales) {
      if (suc.name === sucClick.name) {
        suc.check = !suc.check;
      }else{
        suc.check = false;
      }
    }

    if (sucClick.name === 'Consolidado') {
      this.consolidado = true;
    }else{
      this.consolidado = false;
    }
    this.sucursalSeleccionada = sucClick;
    this.initPeriodos();
  }
  public filtroSegmento(seg){
    let i = 0;
    for (const segmento of this.segmentos) {
      if (segmento.name === seg.name) {
        segmento.check = !segmento.check;
        this.segmentoEnc = segmento;
        this.encMet  = segmento.movimiento ? this.encMet : 1;
      }else{
        segmento.check = false;
      }
      i++;
    }
    const s = this.dataVisible.filter(d => d.id == this.segmentoEnc.id)[0];
    this.selectSegmento(s);
  }

   // Método para manejar el cambio del filtro Sin Saldo
  public onSinSaldoChange() {
    this.sinSaldo = !this.sinSaldo;
    this.actualizarCuentasVisibles();
  }
  public selectSegmento(seg){
    this.segmentoSelect = seg;
    this.historicoSegmento();
  }
  private calcularVariacion(presupuesto: number | string, real: number | string): number | string {
    // Si presupuesto o real es guion, devolver guion
    if (presupuesto === '-' || real === '-') {
      return '-';
    }
    
    // Convertir a números y restar: real - presupuesto
    const numPresupuesto = Number(presupuesto);
    const numReal = Number(real);
    const variacion = Number((numReal - numPresupuesto).toFixed(2));
    
    return variacion;
  }
  
  private generarSemaforosParaInstitucion(): void {
    // Generar entre 3 y 5 semáforos aleatorios para la institución
    const colores = ['#4CAF50','#FF4444'];
    const min = [100, -100];
    const max = [1000, 99.9999]
    const minv = [0, 0.0111111111];
    const maxv = [-999999999999999, 999999999999999]
    
    // Semáforos para VARIACIÓN    
    for (let i = 0; i < colores.length; i++) {
      this.semaforosVariacion.push({
        min: minv[i],
        max: maxv[i],
        color: colores[i]
      });
    }

    // Semáforos para CUMPLIMIENTO (rangos de porcentaje: 0-100)
    this.semaforos = [];
    let minRangoPor = 0;
    
    for (let i = 0; i < colores.length; i++) {
      const maxRangoPor = minRangoPor + (100 / colores.length);
      this.semaforos.push({
        min: min[i],
        max: max[i],
        color: colores[i]
      });
      minRangoPor = maxRangoPor;
    }
  }

  public obtenerColorSemaforo(valor: number | string, esVariacion: boolean = false): string {
    // Si es guion o no es un número, no aplicar color
    if (valor === '-' || isNaN(Number(valor))) {
      return 'black';
    }

    const numValor = Number(valor);
    const semaforosAusar = esVariacion ? this.semaforosVariacion : this.semaforos;
    const semaforo = semaforosAusar.find(s => numValor >= s.min && numValor <= s.max);
    return semaforo ? semaforo.color : 'black';
  }

  public resetFilters(){
    const ultimoAnio = this.Periodos[this.Periodos.length - 1];

    if (ultimoAnio) {
      this.periodoSeleccionado = ultimoAnio.series[ultimoAnio.series.length - 1];
      this.periodoSeleccionado.check = true;
    }

    for (const esc of this.escenarios) {
      esc.check = false;
    }
    this.escenarios[0].check = true;
    this.escenarioSeleccionado = this.escenarios[0];

    for (const suc of this.sucursales) {
      suc.check = false;
    }
    for(const seg of this.segmentos){
      seg.check = false;
    }
    this.consolidado = true;
    this.sucursales[0].check = true;
    this.sucursalSeleccionada = this.sucursales[0];
    this.segmentos[0].check = true;
    this.segmentoEnc = this.segmentos[0];
    this.posSelect = 0;
    this.tipoGraf = this.typeGraph.COMBO;
    this.etiqueta = false;
    this.encMet = 1;
    this.initPeriodos();
  }
  public cambiarTipoGrafica(type){
    this.tipoGraf = type;
  }
  public ampliarGraf(zona){
    this.modalOpen = true;
  }
  public exportarGrafica(zona, graf?){
    this.subtituloGrafica = `${this.translate.instant('segPresupuestal.razonesFinancieras.evolucion')} ${this.segmentoSelect.nombre} ${this.periodoSeleccionado.nombre} | ${this.escenarioSeleccionado.name}`
    
    var name = { 
      titulo: this.translate.instant('menu.'+this.dataService.subModuleSelect),
      subtitulo: this.subtituloGrafica,
      nombreArch: this.translate.instant('menu.'+this.dataService.subModuleSelect)
    }
    
    const comp = this.grafCmp.find(g => g.zona === zona);
    comp.exportImg(zona,name)
  }
  public async exportarTabla(){
    try {
      const suc = this.consolidado ? '' : this.translate.instant('segPresupuestal.analisisSegmento.sucursal'+this.tagInstitucion);
      let titulo = `Análisis por segmento | ${suc} ${this.sucursalSeleccionada.name} | ${this.periodoSeleccionado.nombre} | ${this.escenarioSeleccionado.name}`;
      const encabezados = ['Código', 'Descripción', 'Presupuesto'];
      const encabezados1 = ['',''];

      encabezados.push('Ejecutado', 'Variación', 'Cumplimiento');
      if(this.encMet == 2 ){
        titulo += ` | Movimientos del mes`
        encabezados1.push(this.translate.instant('segPresupuestal.estadoFinanciero.tituloTabla3'),'','','',this.translate.instant('segPresupuestal.estadoFinanciero.tituloTabla2'),'','','')
        encabezados.push('Presupuesto', 'Ejecutado', 'Variación', 'Cumplimiento');
      }
      await this.excelService.generateEstadosFinancierosConAnalisis(
        titulo,
        encabezados1,
        encabezados,
        this.dataVisible,
        'Analisis-Segmentos',
        false,
        this.semaforo,
        this.semaforosVariacion,
        this.semaforos,
        this.encMet
      );
    } catch (error) {
      messages.errorMessageGraph(this.translate.instant('segPresupuestal.estadoFinanciero.noExcel'))
    }
  }
  public toggleExpansion(cuenta: any) {
      cuenta.expandido = !cuenta.expandido;
      this.actualizarCuentasVisibles();
  }

  public getIndentacion(cuenta: any): string {
    if(cuenta.nivel == 1){
      return '10px'
    }else{
      return `${((cuenta.nivel - 1) * 20)+10}px`;
    }
  }
  public async cambioConsolidadoSaldo(metSelec){
    this.encMet = metSelec;
    this.historicoSegmento();
  }
  //Metodo para la expansion y contraccion de todas las cuentas.
  public contraerExpandirTodo(){
    this.contraerExpandir = !this.contraerExpandir;

    const recorrer = (cuentas:any[]) => {
      cuentas.forEach(cuenta => {
        cuenta.expandido = this.contraerExpandir;
        recorrer(cuenta.hijos);
      });
    }
    recorrer(this.segmentosJerarquia);
    this.actualizarCuentasVisibles();
  }
}
